import React from 'react';

import UserInfoTransferSection from './UserInfoTrasferSection';
import UserInfoEditSection from './UserInfoEditSection';
import { useAccountUserDetailQueryV2 } from '../common/hooks';
import { AccountUserDetailTypeV2 } from '../common/types/accountUserDetail';
import toastMsg from '../../../../../lib/toastMsg';
import accountUserToastMsg from '../../../../../constants/service/toastMsg/accountUserToastMsg';
import './AccountUserDetailUserInfo.scss';

interface IAccountUserDetailUserInfoProps {
  userId: number;
  isActive: boolean;
}

const AccountUserDetailUserInfo = (props: IAccountUserDetailUserInfoProps): JSX.Element => {
  const { userId, isActive } = props;

  const { data: userDetailInfo, isLoading } = useAccountUserDetailQueryV2<AccountUserDetailTypeV2>({
    userId,
    options: {
      enabled: !!userId && isActive,
      onSuccess: () => toastMsg.success(accountUserToastMsg.GET_USER_DETAIL_REQUEST_SUCCESS),
      onError: (error) => toastMsg.error(error.message),
      select: (result) => result.user,
    },
  });

  if (isLoading || !userDetailInfo) return <></>;

  return (
    <div className="account-user-detail-content">
      <UserInfoTransferSection userDetailInfo={userDetailInfo} />
      <UserInfoEditSection userId={userId} isActive={isActive} userDetailInfo={userDetailInfo} />
    </div>
  );
};

export default AccountUserDetailUserInfo;
